import { serverResponse } from 'app'
import Access from 'global-utils/models/Access'
import Match from 'global-utils/models/sports/soccer/Match'

import * as actions from '../actions'

const stagetMatchesToObject = (stage) =>
  stage.rounds.forEach((round) => {
    round.matches.forEach((match, index) => {
      round.matches[index] = new Match(match)
    })
  })

const changeLike = (state, liked) => {
  const newState = serverResponse(state)

  if (liked) {
    newState.data[0].liked = { liked: true }
    newState.data[0].following = { follow: true }
    newState.data[0].likes_count = (newState.data[0].likes_count || 0) + 1
    newState.data[0].follows_count = (newState.data[0].follows_count || 0) + 1
  } else {
    newState.data[0].liked = null
    newState.data[0].following = null
    newState.data[0].likes_count = (newState.data[0].likes_count || 1) - 1
    newState.data[0].follows_count = (newState.data[0].follows_count || 1) - 1
  }

  newState.data[0] = { ...newState.data[0] }

  return newState
}

const moveTeam = (state, stageId, teamId, group, position) => {
  const newState = serverResponse(state, {
    data: [
      {
        ...state.data[0],
        tournament: {
          ...state.data[0].tournament,
        },
      },
    ],
  })

  const stage = newState.data[0].tournament.stages.find((s) => s.id === stageId)
  if (stage) {
    const stageTeam = stage.teams.find((t) => t.team.id === teamId)
    if (stageTeam) {
      stageTeam.group = group

      const stageGroupTeams = stage.teams
        .filter((t) => t.group === group && t.team.id !== teamId)
        .sort((team1, team2) => team1.position - team2.position)

      stageGroupTeams.splice(position - 1, 0, stageTeam)

      stageGroupTeams.forEach((team, index) => {
        team.position = index + 1
      })
    }
  }

  return newState
}

export default (state = actions.getInitialState(), action = {}) => {
  switch (action.type) {
    case actions.TOURNAMENT_PAGE_FETCH: {
      return state
    }
    case actions.TOURNAMENT_PAGE_FETCH_CANCELED: {
      return serverResponse(state)
    }
    case actions.TOURNAMENT_PAGE_FETCH_ERROR: {
      return action.payload
    }
    case actions.TOURNAMENT_PAGE_FETCH_FULFILLED: {
      const newState = action.payload
      if (newState.data?.[0]?.access) {
        newState.data[0].access = new Access(newState.data[0].access)
      }
      if (newState.data?.[0]?.tournament?.stages) {
        newState.data[0].tournament.stages.forEach(stagetMatchesToObject)
      }

      return newState
    }

    case actions.TOURNAMENT_PAGE_LIKE: {
      return changeLike(state, action.payload.like)
    }
    case actions.TOURNAMENT_PAGE_LIKE_CANCELED: {
      return changeLike(state, !state.data[0].liked)
    }
    case actions.TOURNAMENT_PAGE_LIKE_ERROR: {
      const newState = changeLike(state, !action.payload.originalAction.like)
      newState.error = action.payload.error
      return newState
    }
    case actions.TOURNAMENT_PAGE_LIKE_FULFILLED: {
      return changeLike(state, !!action.payload.data[0].like)
    }

    case actions.TOURNAMENT_PAGE_RELATION_FETCH: {
      return serverResponse(state, { loading: true })
    }
    case actions.TOURNAMENT_PAGE_RELATION_FETCH_CANCELED: {
      return serverResponse(state)
    }
    case actions.TOURNAMENT_PAGE_RELATION_FETCH_ERROR: {
      return serverResponse(state, { error: action.payload.error })
    }
    case actions.TOURNAMENT_PAGE_RELATION_FETCH_FULFILLED: {
      const data = action.payload.data[0]
      const newState = serverResponse(state)
      newState.data[0] = { ...newState.data[0], ...data }
      newState.data[0].access = new Access(newState.data[0].access)
      return newState
    }

    case actions.TOURNAMENT_PAGE_STAGE_TEAM_RELOCATE_FETCH: {
      return moveTeam(
        state,
        action.payload.stage_id,
        action.payload.team_id,
        action.payload.group,
        action.payload.position,
      )
    }
    case actions.TOURNAMENT_PAGE_STAGE_TEAM_RELOCATE_FETCH_CANCELED: {
      return serverResponse(state)
    }
    case actions.TOURNAMENT_PAGE_STAGE_TEAM_RELOCATE_FETCH_ERROR: {
      return serverResponse(state, { error: action.payload.error })
    }
    case actions.TOURNAMENT_PAGE_STAGE_TEAM_RELOCATE_FETCH_FULFILLED: {
      const data = action.payload.data[0]
      const newState = serverResponse(state, {
        data: [
          {
            ...state.data[0],
            tournament: {
              ...state.data[0].tournament,
            },
          },
        ],
      })

      newState.data[0].tournament.stages.forEach((stage, index) => {
        if (stage.id === data.id) {
          stagetMatchesToObject(data)
          newState.data[0].tournament.stages[index] = data
        }
      })

      return newState
    }

    default:
  }
  return state
}
